import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { InventoryTypeService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  InventoryTypeCreateDto,
  InventoryTypeDto,
  InventoryTypeExcelDownloadDto,
  InventoryTypeUpdateDto,
} from '../proxy/planning/dtos/inventory-type';
import { INVENTORYTYPE_CONFIG, INVENTORYTYPE_FIELDS } from './inventory-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-inventory-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, InventoryTypeService, ConfirmationService],
  templateUrl: './inventory-type.html',
  styleUrl: './inventory-type.scss',
})
export class InventoryType extends BaseCrudComponent<
  InventoryTypeDto,
  InventoryTypeCreateDto,
  InventoryTypeUpdateDto,
  InventoryTypeExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(InventoryTypeService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('InventoryType', ids),
  };
  config = INVENTORYTYPE_CONFIG;
  fields = INVENTORYTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: InventoryTypeDto): InventoryTypeUpdateDto {
    return {
      name: data.name,
      isRealInventory: data.isRealInventory,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'InventoryType';
  }
}
